const e=async(e,t,n,r,i)=>{let{data:a}=await e.get(`/webhooks/${t}/${n}/${r}/subscriptions/${i}`);return a};export{e as getWebhookSubscription};
//# sourceMappingURL=get-subscription.mjs.map